import { Divider } from "@mui/material";

export const AppDivider = () => (
  <div style={{ margin: "20px 0" }}>
    <Divider light sx={{ width: "100%" }} />
  </div>
);
